import type { ToolsType } from "./types";

export const TOOLS_FOLDER = ".workspace/tools";
export const TOOLS_SCOPE = "workspace";
export const TOOLS_BRANCH = "master";
export const GROUP_FOLDER: Record<ToolsType, string> = { fragment: "fragments", template: "templates" };
